(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-carousel"] && !window.DesignMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const wrapper = document.querySelector('.ilmoitus-karuselli-wrapper');
  if (!wrapper) return;

  const track = wrapper.querySelector('.ilmoitus-karuselli-track');
  const leftBtn = wrapper.querySelector('.ilmoitus-nav.vasen');
  const rightBtn = wrapper.querySelector('.ilmoitus-nav.oikea');

  let currentIndex = 0;
  const items = track.children;

  function slidesPerView() {
    return window.innerWidth >= 768 ? 2 : 1;
  }

  function updateScroll() {
    const slideWidth = items[0].offsetWidth;
    track.style.transform = `translateX(-${currentIndex * slideWidth}px)`;

    leftBtn.style.display = currentIndex > 0 ? 'flex' : 'none';
    rightBtn.style.display = currentIndex < items.length - slidesPerView() ? 'flex' : 'none';
  }

  function scrollLeft() {
    if (currentIndex > 0) {
      currentIndex--;
      updateScroll();
    }
  }

  function scrollRight() {
    if (currentIndex < items.length - slidesPerView()) {
      currentIndex++;
      updateScroll();
    }
  }

  leftBtn.addEventListener('click', scrollLeft);
  rightBtn.addEventListener('click', scrollRight);
  window.addEventListener('resize', updateScroll);
  updateScroll();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer-trust-icons"] && !window.DesignMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const track = document.querySelector(".trust-icons-track");
  const items = Array.from(document.querySelectorAll(".trust-icon-item"));
  const prevBtn = document.querySelector(".trust-prev");
  const nextBtn = document.querySelector(".trust-next");
  const pagination = document.querySelector(".trust-icons-pagination");
  const carousel = document.querySelector(".trust-icons-carousel");

  if (!track || items.length === 0) return;

  let currentPage = 0;
  let itemsPerPage = getItemsPerPage();
  let totalPages = Math.ceil(items.length / itemsPerPage);
  let autoplayInterval;

  function getItemsPerPage() {
    return window.innerWidth < 768 ? 1 : 2;
  }

  function updateLayout() {
    itemsPerPage = getItemsPerPage();
    totalPages = Math.ceil(items.length / itemsPerPage);

    // Asetetaan oikea leveys jokaiselle itemille
    const itemWidth = carousel.offsetWidth / itemsPerPage;
    items.forEach(item => {
      item.style.flex = `0 0 ${itemWidth}px`;
    });

    // Päivitä sijainti
    updateSlider();
  }

  function updateSlider() {
    const itemWidth = carousel.offsetWidth / itemsPerPage;
    const offset = currentPage * itemWidth * itemsPerPage;
    track.style.transform = `translateX(-${offset}px)`;

    pagination.textContent = `${currentPage + 1}/${totalPages}`;
    prevBtn.disabled = currentPage === 0;
    nextBtn.disabled = currentPage >= totalPages - 1;
  }

  function goToNextSlide() {
    currentPage = (currentPage + 1) % totalPages;
    updateSlider();
  }

  function goToPreviousSlide() {
    if (currentPage > 0) {
      currentPage--;
      updateSlider();
    }
  }

  prevBtn.addEventListener("click", () => {
    goToPreviousSlide();
    resetAutoplay();
  });

  nextBtn.addEventListener("click", () => {
    goToNextSlide();
    resetAutoplay();
  });

  function startAutoplay() {
    autoplayInterval = setInterval(goToNextSlide, 5000);
  }

  function resetAutoplay() {
    clearInterval(autoplayInterval);
    startAutoplay();
  }

  window.addEventListener("resize", () => {
    currentPage = 0;
    updateLayout();
  });

  updateLayout();
  startAutoplay();
});

  } catch(e) { console.error(e); }
})();
})();
